export default "__VITE_ASSET__CXz5xkK6__"